import { colors } from "./constants/colors";
import { createTheme } from "@mui/material";

export const theme = createTheme();

export const drawerWidth = {
  xs: 300,
  sm: 400,
  md: 450,
};

export const styles = {
  appContainer: {
    display: "flex",
  },
  appBar: (drawerOpen, drawerWidth) => ({
    backgroundColor: colors.prussian_blue.DEFAULT,
    width: {
      xs: !drawerOpen ? "100%" : `calc(100% - ${drawerWidth.xs}px)`,
      sm: !drawerOpen ? "100%" : `calc(100% - ${drawerWidth.sm}px)`,
    },
    transition: (theme) =>
      theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    boxShadow: 1,
  }),
  title: {
    color: colors.white.DEFAULT,
    fontWeight: "bold",
  },
  menuIcon: {
    color: colors.white.DEFAULT,
  },
  drawer: (drawerOpen, drawerWidth) => ({
    width: {
      xs: `${drawerOpen ? drawerWidth.xs : 0}px`,
      sm: `${drawerOpen ? drawerWidth.sm : 0}px`,
    },
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: {
        xs: drawerWidth.xs,
        sm: drawerWidth.sm,
      },
      boxSizing: "border-box",
      padding: 0,
      backgroundColor: colors.blue_green[900],
      touchAction: "none",
    },
  }),
  drawerHeader: {
    backgroundColor: colors.blue_green[600],
    display: "flex",
    justifyContent: "center",
    color: colors.sky_blue[100],
  },
  drawerHeaderText: {
    color: colors.blue_green[900],
    fontWeight: "bold",
  },
  drawerContent: {
    overflow: "auto",
    p: 2,
    paddingTop: 5,
  },
  mainContent: {
    display: "flex",
    width: "100%",
    height: "100vh",
    backgroundColor: colors.white.DEFAULT,
  },
  mainBox: {
    flexGrow: 1,
    p: { xs: 1, sm: 3 },
    width: "100%", //TODO: was 50% changing didn't work
    transition: (theme) =>
      theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "1300px", // TODO: was 800px changing didn't work
    margin: "0 auto",
  },
  resultsContainer: {
    width: "100%",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    background: `linear-gradient(90deg, ${colors.blue_green[600]} 10%, ${colors.prussian_blue[400]} 90%)`,
  },
  tutorialContainer: {
    width: "100%",
    mt: { xs: 0, sm: 0, md: 0, lg: 8 },
    p: { xs: 2, sm: 0, md: 0, lg: 3 },
    // mt: { xs: 10, sm: 8 },
  },
};
